import { create } from "zustand";

export const useTaskModalStore = create((set) => ({
  // Comment / attachment UI state
  expandedCommentIds: new Set(),
  draftAttachmentsExpanded: false,
  draftExistingAttachments: [],
  draftUploadAttachments: [],

  // Composer state
  newComment: "",

  // Picker / upload modal state
  pickerTarget: null,
  selectedFileId: null,
  selectedPickerFile: null,
  uploadTarget: null,

  // ── Comment attachment expand ──
  toggleCommentAttachments: (commentId) =>
    set((state) => {
      const next = new Set(state.expandedCommentIds);
      if (next.has(commentId)) next.delete(commentId);
      else next.add(commentId);
      return { expandedCommentIds: next };
    }),

  // ── Draft attachment summary ──
  setDraftAttachmentsExpanded: (val) => set({ draftAttachmentsExpanded: val }),
  toggleDraftAttachments: () =>
    set((state) => ({ draftAttachmentsExpanded: !state.draftAttachmentsExpanded })),

  addDraftExistingAttachment: (item) =>
    set((state) => {
      if (state.draftExistingAttachments.some((a) => a.fileId === item.fileId)) return state;
      return { draftExistingAttachments: [...state.draftExistingAttachments, item] };
    }),

  addDraftUploadAttachments: (items) =>
    set((state) => ({
      draftUploadAttachments: [...state.draftUploadAttachments, ...items],
    })),

  removeDraftAttachment: (key) =>
    set((state) => ({
      draftExistingAttachments: state.draftExistingAttachments.filter((a) => a.key !== key),
      draftUploadAttachments: state.draftUploadAttachments.filter((a) => a.key !== key),
    })),

  clearDraftAttachments: () =>
    set({ draftExistingAttachments: [], draftUploadAttachments: [], draftAttachmentsExpanded: false }),

  // ── Composer ──
  setNewComment: (val) => set({ newComment: val }),

  // ── Picker / upload modals ──
  openPicker: (target) => set({ pickerTarget: target, selectedFileId: null, selectedPickerFile: null }),
  closePicker: () => set({ pickerTarget: null, selectedFileId: null, selectedPickerFile: null }),
  setSelectedFile: (id, file) => set({ selectedFileId: id, selectedPickerFile: file }),

  openUpload: (target) => set({ uploadTarget: target }),
  closeUpload: () => set({ uploadTarget: null }),

  // ── Full reset ──
  reset: () =>
    set({
      expandedCommentIds: new Set(),
      draftAttachmentsExpanded: false,
      draftExistingAttachments: [],
      draftUploadAttachments: [],
      newComment: "",
      pickerTarget: null,
      selectedFileId: null,
      selectedPickerFile: null,
      uploadTarget: null,
    }),
}));
